import React, { useState, useEffect } from "react";
import styles from "./TemplateHero21.module.css";

const TemplateHero21 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4500);

    return () => clearInterval(interval);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const getCardStyle = (index) => {
    const total = slides.length;
    const diff = ((index - currentSlide) % total + total) % total;

    if (diff === 0) {
      return {
        transform: "translateX(0) scale(1) rotateY(0deg)",
        zIndex: total,
        opacity: 1,
      };
    } else if (diff === 1 || diff === total - 1) {
      const dir = diff === 1 ? 1 : -1;
      return {
        transform: `translateX(${dir * 52}%) scale(0.85) rotateY(${-dir * 12}deg)`,
        zIndex: total - 1,
        opacity: 0.65,
      };
    } else {
      const dir = diff < total / 2 ? 1 : -1;
      return {
        transform: `translateX(${dir * 90}%) scale(0.7) rotateY(${-dir * 20}deg)`,
        zIndex: total - 2,
        opacity: 0.3,
      };
    }
  };

  return (
    <div className={styles.heroRoot}>
      <div className={styles.heroInner}>
        
        {/* LEFT TEXT */}
        <div className={styles.heroText}>
          <div className={styles.eyebrow}>
            {branding?.companyName || "Premium Travel"}
          </div>

          <h1 className={styles.title}>
            Journeys That <em>Inspire</em>
          </h1>

          <p className={styles.subtitle}>
            {slides[currentSlide].subtitle}
          </p>

          <div className={styles.actions}>
            <button className={styles.mainBtn}>View All Packages</button>
            <button className={styles.ghostBtn}>
              <span>↓</span> Scroll to explore
            </button>
          </div>

          <div className={styles.progress}>
            {slides.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentSlide(i)}
                className={`${styles.progressItem} ${
                  i === currentSlide ? styles.active : ""
                }`}
              />
            ))}
          </div>
        </div>

        {/* CARD STACK */}
        <div className={styles.stage}>
          {slides.map((slide, i) => {
            const cardStyle = getCardStyle(i);
            const isActive = i === currentSlide;

            return (
              <div
                key={i}
                style={cardStyle}
                onClick={() => setCurrentSlide(i)}
                className={`${styles.card} ${isActive ? styles.activeCard : ""}`}
              >
                <div
                  className={styles.cardImg}
                  style={{ backgroundImage: `url('${slide.image}')` }}
                />

                <div className={styles.cardInfo}>
                  <div className={styles.cardNum}>
                    {String(i + 1).padStart(2, "0")}
                  </div>

                  <p className={styles.cardTitle}>{slide.title}</p>

                  <p className={styles.cardSub}>
                    {slide.subtitle?.substring(0, 55)}...
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default TemplateHero21;